import { Manager } from 'socket.io-client'
import { serverBaseUrl } from './environment'

class IO {
  manager = new Manager(serverBaseUrl)
  userId = null
  sockets = {}
  setUserId (userId) {
    this.userId = userId
  }

  socket (namespace) {
    if (this.sockets[namespace]) {
      return this.sockets[namespace]
    }
    if (!this.manager) {
      throw new Error("Can't create a socket before setting id token")
    }
    this.sockets[namespace] = this.manager.socket(namespace, {
      auth: {
        userId: this.userId
      }
    })
    return this.sockets[namespace]
  }
}

const io = new IO()

export { io }
